// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <detail-view
  :endpoint="endpoint + 'reportconfigs'"
  :hiddenValues="hiddenValues"
  name="Map"
  parentRoute="reportConfigs"
  permissions="reportconfigs"
  :values="values"
  ></detail-view>
</template>
<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import DetailView from '@sdgsystems/vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Type',
                value: 'type',
                context: ENDPOINT + 'reporttypes',
                itemText: 'type',
                itemValue: 'type',
                type: 'select',
                required: true
              },
              {
                name: 'Format',
                value: 'format',
                context: ENDPOINT + 'reportformat',
                itemText: 'format',
                itemValue: 'format',
                type: 'select',
                required: true
              },
              {
                name: 'Email',
                value: 'email',
                type: 'checkbox'
              },
              {
                name: 'Zones',
                value: 'zones',
                context: ENDPOINT + 'zones',
                type: 'select',
                itemText: 'name',
                itemValue: '_id',
                multiple: true,
                width: 'xs12'
              },
              {
                name: 'Categories',
                value: 'categories',
                context: ENDPOINT + 'categories',
                type: 'select',
                itemText: 'name',
                itemValue: '_id',
                multiple: true,
                width: 'xs12'
              },
              {
                name: 'Headings',
                value: 'headings',
                type: 'combobox',
                multiple: true,
                width: 'xs12'
              }
            ]
          ]
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ]),

    hiddenValues: function () {
      return [{
        path: 'site',
        value: this.selectedSite._id
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ReportConfigEdit.vue